// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.esc-menu {
  position: fixed;
  inset: 0;
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: "Din-pro", "Segoe UI", system-ui, sans-serif;
  color: #ebe8e1;
  background: rgba(4, 6, 8, 0.74);
  backdrop-filter: blur(5px);
  animation: esc-fade 0.18s ease-out;
  zoom: calc(1 / var(--applied-zoom, 1));
  --u: clamp(0.7115px, 0.05208vw, 1.7917px);
}
.esc-menu--reduced-motion, .esc-menu--reduced-motion * {
  animation-duration: 1ms !important;
  transition-duration: 1ms !important;
}
@media (prefers-reduced-motion: reduce) {
  .esc-menu, .esc-menu * {
    animation-duration: 1ms !important;
    transition-duration: 1ms !important;
  }
}
.esc-menu *, .esc-menu *::before, .esc-menu *::after {
  box-sizing: border-box;
}
.esc-menu h1, .esc-menu h2, .esc-menu h3, .esc-menu p, .esc-menu ul, .esc-menu dl, .esc-menu dd {
  margin: 0;
  padding: 0;
}
.esc-menu ul {
  list-style: none;
}
.esc-menu button {
  font-family: inherit;
}

@keyframes esc-fade {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@keyframes esc-rise {
  from {
    opacity: 0;
    transform: translateY(8px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
.esc-panel {
  display: grid;
  grid-template-columns: max(210px, calc(264 * var(--u))) minmax(0, 1fr);
  width: min(max(calc(1420 * var(--u)), 940px), 96vw);
  height: min(max(calc(900 * var(--u)), 600px), 92vh);
  background: #0f1418;
  border: 1px solid rgba(255, 255, 255, 0.18);
  border-radius: 6px;
  box-shadow: 0 28px 80px rgba(0, 0, 0, 0.65);
  overflow: hidden;
  animation: esc-rise 0.2s ease-out;
}

.esc-rail {
  display: flex;
  flex-direction: column;
  min-height: 0;
  padding: calc(28 * var(--u)) calc(18 * var(--u)) calc(22 * var(--u));
  background: #090c0f;
  border-right: 1px solid rgba(255, 255, 255, 0.08);
}

.esc-brand {
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding: 0 calc(10 * var(--u)) calc(26 * var(--u));
}

.esc-brand__name {
  font-family: "Marcellus", "Cinzel", Georgia, serif;
  font-size: max(20.8px, 26 * var(--u));
  letter-spacing: 0.04em;
  color: var(--gold-light);
}

.esc-brand__sub {
  font-size: max(9.6px, 12 * var(--u));
  color: #8d8a82;
}

.esc-nav {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.esc-nav__item {
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 2px;
  width: 100%;
  padding: calc(12 * var(--u)) calc(14 * var(--u)) calc(12 * var(--u)) calc(18 * var(--u));
  text-align: left;
  color: #b0ada4;
  background: transparent;
  border: 0;
  border-radius: 6px;
  cursor: pointer;
  transition: background-color 0.12s ease, color 0.12s ease;
}
.esc-nav__item::before {
  content: "";
  position: absolute;
  left: 0;
  top: 22%;
  bottom: 22%;
  width: 3px;
  border-radius: 2px;
  background: var(--gold-main);
  opacity: 0;
  transition: opacity 0.12s ease;
}
.esc-nav__item:hover {
  background: rgba(255, 255, 255, 0.05);
  color: #ebe8e1;
}
.esc-nav__item--active {
  background: rgba(255, 255, 255, 0.07);
  color: #ebe8e1;
}
.esc-nav__item--active::before {
  opacity: 1;
}
.esc-nav__item--active .esc-nav__label {
  color: var(--gold-light);
}
.esc-nav__item:focus-visible {
  outline: 2px solid var(--gold-light);
  outline-offset: 2px;
}

.esc-nav__label {
  font-size: max(13.6px, 17 * var(--u));
  font-weight: 600;
}

.esc-nav__hint {
  font-size: max(9.6px, 12 * var(--u));
  color: #8d8a82;
}

.esc-rail__foot {
  display: flex;
  flex-direction: column;
  gap: calc(10 * var(--u));
  margin-top: auto;
  padding-top: calc(18 * var(--u));
}

.esc-identity {
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding: calc(12 * var(--u)) calc(14 * var(--u));
  background: #151b21;
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 6px;
}

.esc-identity__name {
  font-size: max(12px, 15 * var(--u));
  font-weight: 600;
  color: #ebe8e1;
  overflow-wrap: anywhere;
}

.esc-identity__gold {
  font-size: max(10.4px, 13 * var(--u));
  color: var(--gold-light);
}

.esc-rail__resume {
  justify-content: space-between;
  width: 100%;
}

.esc-rail__quit {
  width: 100%;
}

.esc-content {
  display: flex;
  flex-direction: column;
  min-width: 0;
  min-height: 0;
}

.esc-content__head {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: calc(24 * var(--u));
  flex-wrap: wrap;
  padding: calc(30 * var(--u)) calc(40 * var(--u)) calc(20 * var(--u));
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
}

.esc-content__title {
  font-family: "Marcellus", "Cinzel", Georgia, serif;
  font-weight: 400;
  font-size: max(28.8px, 36 * var(--u));
  line-height: 1.1;
  color: #ebe8e1;
}

.esc-content__lead {
  margin-top: calc(6 * var(--u));
  font-size: max(12px, 15 * var(--u));
  color: #b0ada4;
}

.esc-page {
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
  padding: calc(28 * var(--u)) calc(40 * var(--u)) calc(36 * var(--u));
  scrollbar-gutter: stable;
  scrollbar-width: thin;
  scrollbar-color: #252f37 transparent;
}
.esc-page::-webkit-scrollbar {
  width: 8px;
}
.esc-page::-webkit-scrollbar-track {
  background: transparent;
}
.esc-page::-webkit-scrollbar-thumb {
  background: #252f37;
  border-radius: 4px;
}
.esc-page::-webkit-scrollbar-thumb:hover {
  background: var(--gold-dark);
}

.esc-card {
  padding: calc(22 * var(--u)) calc(24 * var(--u));
  background: #151b21;
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 6px;
}
.esc-card--flush {
  padding: 0;
  overflow: hidden;
}

.esc-card__title {
  margin-bottom: calc(14 * var(--u));
  font-family: "Marcellus", "Cinzel", Georgia, serif;
  font-weight: 400;
  font-size: max(16px, 20 * var(--u));
  color: #ebe8e1;
}
.esc-card__title--padded {
  margin: 0;
  padding: calc(18 * var(--u)) calc(24 * var(--u)) calc(12 * var(--u));
}

.esc-prose {
  font-size: max(12px, 15 * var(--u));
  line-height: 1.6;
  color: #b0ada4;
  max-width: 68ch;
  white-space: pre-wrap;
  overflow-wrap: anywhere;
}

.esc-empty {
  padding: calc(20 * var(--u)) calc(24 * var(--u));
  font-size: max(12px, 15 * var(--u));
  color: #8d8a82;
}

.esc-hint {
  margin-top: calc(10 * var(--u));
  font-size: max(10.4px, 13 * var(--u));
  line-height: 1.5;
  color: #8d8a82;
}
.esc-hint--padded {
  margin: 0;
  padding: 0 calc(24 * var(--u)) calc(18 * var(--u));
}

.esc-kbd {
  display: inline-block;
  padding: 2px 8px;
  font-family: "Din-pro", "Segoe UI", system-ui, sans-serif;
  font-size: max(9.6px, 12 * var(--u));
  color: #ebe8e1;
  background: #252f37;
  border: 1px solid rgba(255, 255, 255, 0.18);
  border-radius: 4px;
}

.esc-code {
  font-family: Consolas, "Courier New", monospace;
  font-size: max(11.2px, 14 * var(--u));
  color: var(--gold-light);
}

.esc-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: calc(10 * var(--u));
  padding: calc(10 * var(--u)) calc(18 * var(--u));
  font-size: max(11.2px, 14 * var(--u));
  font-weight: 600;
  line-height: 1.2;
  color: #ebe8e1;
  background: #1c242b;
  border: 1px solid rgba(255, 255, 255, 0.18);
  border-radius: 6px;
  cursor: pointer;
  transition: background-color 0.12s ease, border-color 0.12s ease, color 0.12s ease, transform 0.08s ease;
}
.esc-btn:hover:not(:disabled) {
  background: #252f37;
  border-color: var(--gold-dark);
}
.esc-btn:active:not(:disabled) {
  transform: translateY(1px);
}
.esc-btn:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}
.esc-btn:focus-visible {
  outline: 2px solid var(--gold-light);
  outline-offset: 2px;
}
.esc-btn--primary {
  color: #14100a;
  background: var(--gold-main);
  border-color: var(--gold-main);
}
.esc-btn--primary .esc-kbd {
  color: #14100a;
  background: rgba(0, 0, 0, 0.14);
  border-color: rgba(0, 0, 0, 0.25);
}
.esc-btn--primary:hover:not(:disabled) {
  background: var(--gold-light);
  border-color: var(--gold-light);
}
.esc-btn--danger {
  color: #d9786d;
  background: transparent;
  border-color: rgba(217, 120, 109, 0.45);
}
.esc-btn--danger:hover:not(:disabled) {
  background: rgba(217, 120, 109, 0.14);
  border-color: #d9786d;
}
.esc-btn--quiet {
  color: #8d8a82;
  background: transparent;
  border-color: transparent;
}
.esc-btn--quiet:hover:not(:disabled) {
  color: #d9786d;
  background: rgba(217, 120, 109, 0.14);
  border-color: transparent;
}
.esc-btn--sm {
  padding: calc(6 * var(--u)) calc(12 * var(--u));
  font-size: max(10.4px, 13 * var(--u));
}

.esc-segments {
  display: inline-flex;
  flex-wrap: wrap;
  gap: 2px;
  padding: 3px;
  margin-bottom: calc(18 * var(--u));
  background: #090c0f;
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 6px;
}
.esc-content__head .esc-segments {
  margin-bottom: 0;
}

.esc-segment {
  padding: calc(8 * var(--u)) calc(16 * var(--u));
  font-size: max(11.2px, 14 * var(--u));
  font-weight: 600;
  color: #b0ada4;
  background: transparent;
  border: 0;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.12s ease, color 0.12s ease;
}
.esc-segment:hover {
  color: #ebe8e1;
}
.esc-segment--active {
  color: #14100a;
  background: var(--gold-main);
}
.esc-segment--active:hover {
  color: #14100a;
}
.esc-segment:focus-visible {
  outline: 2px solid var(--gold-light);
  outline-offset: 2px;
}

.esc-form {
  display: flex;
  flex-direction: column;
  gap: calc(8 * var(--u));
  max-width: 640px;
}

.esc-label {
  margin-top: calc(6 * var(--u));
  font-size: max(10.4px, 13 * var(--u));
  font-weight: 600;
  color: #b0ada4;
}

.esc-field {
  width: 100%;
  padding: calc(10 * var(--u)) calc(12 * var(--u));
  font-family: inherit;
  font-size: max(12px, 15 * var(--u));
  color: #ebe8e1;
  background: #090c0f;
  border: 1px solid rgba(255, 255, 255, 0.18);
  border-radius: 6px;
  transition: border-color 0.12s ease;
}
.esc-field:focus {
  outline: none;
  border-color: var(--gold-main);
}
.esc-field::placeholder {
  color: #8d8a82;
}
.esc-field--area {
  min-height: calc(140 * var(--u));
  resize: vertical;
  line-height: 1.5;
}
.esc-field--inline {
  width: calc(120 * var(--u));
  min-width: 90px;
  text-align: right;
}

.esc-form__actions {
  display: flex;
  justify-content: flex-end;
  gap: calc(10 * var(--u));
  margin-top: calc(12 * var(--u));
}

.esc-form__error {
  font-size: max(11.2px, 14 * var(--u));
  color: #d9786d;
}

.esc-dialog-scrim {
  position: fixed;
  inset: 0;
  z-index: 20;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(4, 6, 8, 0.7);
  animation: esc-fade 0.12s ease-out;
}

.esc-dialog {
  display: flex;
  flex-direction: column;
  gap: calc(12 * var(--u));
  width: min(460px, 90vw);
  padding: calc(26 * var(--u)) calc(28 * var(--u));
  background: #151b21;
  border: 1px solid rgba(255, 255, 255, 0.18);
  border-radius: 6px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.6);
}

.esc-dialog__title {
  font-family: "Marcellus", "Cinzel", Georgia, serif;
  font-weight: 400;
  font-size: max(19.2px, 24 * var(--u));
}

.esc-roster {
  display: flex;
  flex-direction: column;
}

.esc-roster__row {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: calc(8 * var(--u)) calc(16 * var(--u));
  padding: calc(12 * var(--u)) calc(24 * var(--u));
  border-top: 1px solid rgba(255, 255, 255, 0.08);
  min-height: calc(54 * var(--u));
}
.esc-roster__row:hover {
  background: rgba(255, 255, 255, 0.025);
}

.esc-roster__name {
  flex: 1 1 28%;
  min-width: 0;
  font-size: max(12px, 15 * var(--u));
  font-weight: 600;
  overflow-wrap: anywhere;
}

.esc-roster__rank {
  flex: 1 1 22%;
  min-width: 0;
  font-size: max(11.2px, 14 * var(--u));
  color: #b0ada4;
}

.esc-roster__seen {
  flex: 0 0 auto;
  min-width: calc(130 * var(--u));
  font-size: max(10.4px, 13 * var(--u));
  text-align: right;
  color: #8d8a82;
}

.esc-roster__actions {
  display: flex;
  flex-wrap: wrap;
  gap: calc(8 * var(--u));
  margin-left: auto;
}

.esc-presence {
  flex: 0 0 auto;
  width: 9px;
  height: 9px;
  border-radius: 50%;
  background: transparent;
  border: 1px solid #8d8a82;
}
.esc-presence--on {
  background: #7fb58a;
  border-color: #7fb58a;
}

.esc-kv {
  display: flex;
  flex-direction: column;
}

.esc-kv__row {
  display: flex;
  align-items: center;
  gap: calc(14 * var(--u));
  padding: calc(12 * var(--u)) 0;
  border-top: 1px solid rgba(255, 255, 255, 0.08);
}
.esc-kv__row:first-child {
  border-top: 0;
  padding-top: 0;
}

.esc-kv__label {
  flex: 1 1 auto;
  font-size: max(12px, 15 * var(--u));
  color: #b0ada4;
}

.esc-kv__value {
  font-size: max(12px, 15 * var(--u));
  font-weight: 600;
  color: var(--gold-light);
}

.esc-character {
  display: grid;
  grid-template-columns: minmax(0, 1.7fr) minmax(0, 1fr);
  grid-template-areas: "id stats" "jobs stats";
  align-items: start;
  gap: calc(20 * var(--u));
}

.esc-identitycard {
  grid-area: id;
  display: flex;
  align-items: center;
  gap: calc(24 * var(--u));
}

.esc-avatar {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  width: calc(112 * var(--u));
  height: calc(112 * var(--u));
  min-width: 76px;
  min-height: 76px;
  font-family: "Marcellus", "Cinzel", Georgia, serif;
  font-size: max(30.4px, 38 * var(--u));
  color: var(--gold-light);
  background: #1c242b;
  border: 1px solid var(--gold-dark);
  border-radius: 6px;
  background-size: cover;
  background-position: center 30%;
}
.esc-avatar--photo {
  color: transparent;
}

.esc-identitycard__text {
  min-width: 0;
}

.esc-identitycard__name {
  font-family: "Marcellus", "Cinzel", Georgia, serif;
  font-weight: 400;
  font-size: max(24px, 30 * var(--u));
  line-height: 1.15;
  overflow-wrap: anywhere;
}

.esc-identitycard__meta {
  margin-top: 2px;
  font-size: max(11.2px, 14 * var(--u));
  color: #8d8a82;
}

.esc-chips {
  display: flex;
  flex-wrap: wrap;
  gap: calc(8 * var(--u));
  margin-top: calc(14 * var(--u));
}

.esc-chip {
  display: flex;
  align-items: baseline;
  gap: calc(8 * var(--u));
  padding: calc(6 * var(--u)) calc(12 * var(--u));
  background: #090c0f;
  border: 1px solid rgba(255, 255, 255, 0.18);
  border-radius: 6px;
}

.esc-chip__name {
  font-size: max(11.2px, 14 * var(--u));
  font-weight: 600;
}

.esc-chip__rank {
  font-size: max(10.4px, 13 * var(--u));
  color: var(--gold-light);
}

.esc-stats {
  grid-area: stats;
  display: flex;
  flex-direction: column;
  gap: calc(12 * var(--u));
}

.esc-stat {
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: calc(18 * var(--u)) calc(22 * var(--u));
  background: #151b21;
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 6px;
}

.esc-stat__value {
  font-family: "Marcellus", "Cinzel", Georgia, serif;
  font-size: max(25.6px, 32 * var(--u));
  line-height: 1.1;
  color: var(--gold-light);
}

.esc-stat__label {
  font-size: max(10.4px, 13 * var(--u));
  color: #8d8a82;
}

.esc-character__jobs {
  grid-area: jobs;
}

.esc-jobs {
  display: flex;
  flex-direction: column;
  gap: calc(18 * var(--u));
}

.esc-job {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  gap: calc(6 * var(--u)) calc(16 * var(--u));
  align-items: center;
}

.esc-job__head {
  display: flex;
  align-items: baseline;
  gap: calc(10 * var(--u));
  min-width: 0;
}

.esc-job__name {
  font-size: max(12.8px, 16 * var(--u));
  font-weight: 600;
}

.esc-job__rank {
  font-size: max(10.4px, 13 * var(--u));
  color: var(--gold-light);
}

.esc-job__xp {
  font-size: max(10.4px, 13 * var(--u));
  color: #8d8a82;
  text-align: right;
}

.esc-meter {
  grid-column: 1/-1;
  height: 6px;
  background: #090c0f;
  border-radius: 3px;
  overflow: hidden;
}

.esc-meter__fill {
  height: 100%;
  background: var(--gold-main);
  border-radius: 3px;
  transition: width 0.3s ease;
}

.esc-faction {
  position: relative;
}

.esc-subtabs {
  display: flex;
  flex-wrap: wrap;
  gap: calc(4 * var(--u));
  margin-bottom: calc(22 * var(--u));
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
}

.esc-subtab {
  position: relative;
  display: inline-flex;
  align-items: center;
  gap: calc(8 * var(--u));
  padding: calc(10 * var(--u)) calc(16 * var(--u));
  margin-bottom: -1px;
  font-size: max(12px, 15 * var(--u));
  font-weight: 600;
  color: #b0ada4;
  background: transparent;
  border: 0;
  border-bottom: 2px solid transparent;
  cursor: pointer;
  transition: color 0.12s ease, border-color 0.12s ease;
}
.esc-subtab:hover {
  color: #ebe8e1;
}
.esc-subtab--active {
  color: var(--gold-light);
  border-bottom-color: var(--gold-main);
}
.esc-subtab:focus-visible {
  outline: 2px solid var(--gold-light);
  outline-offset: 2px;
}

.esc-subtab__count {
  min-width: 22px;
  padding: 1px 7px;
  font-size: max(9.6px, 12 * var(--u));
  text-align: center;
  color: #b0ada4;
  background: #1c242b;
  border-radius: 11px;
}
.esc-subtab__count--alert {
  color: #14100a;
  background: var(--gold-main);
}

.esc-faction__body {
  display: flex;
  flex-direction: column;
  gap: calc(20 * var(--u));
}

.esc-overview {
  display: flex;
  flex-direction: column;
  gap: calc(16 * var(--u));
  max-width: 760px;
}

.esc-overview__id {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: calc(20 * var(--u));
  flex-wrap: wrap;
}

.esc-overview__name {
  font-family: "Marcellus", "Cinzel", Georgia, serif;
  font-weight: 400;
  font-size: max(27.2px, 34 * var(--u));
  line-height: 1.1;
  color: var(--gold-light);
}

.esc-overview__rank {
  display: flex;
  flex-direction: column;
  gap: 2px;
  text-align: right;
}
.esc-overview__rank dt {
  font-size: max(9.6px, 12 * var(--u));
  color: #8d8a82;
}
.esc-overview__rank dd {
  font-size: max(14.4px, 18 * var(--u));
  font-weight: 600;
}

.esc-news {
  display: flex;
  flex-direction: column;
  gap: calc(20 * var(--u));
  max-width: 820px;
}

.esc-posts {
  display: flex;
  flex-direction: column;
  gap: calc(14 * var(--u));
}

.esc-post {
  padding: calc(20 * var(--u)) calc(24 * var(--u));
  background: #151b21;
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-left: 3px solid var(--gold-main);
  border-radius: 6px;
}

.esc-post__head {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: calc(16 * var(--u));
  margin-bottom: calc(8 * var(--u));
}

.esc-post__title {
  font-family: "Marcellus", "Cinzel", Georgia, serif;
  font-weight: 400;
  font-size: max(16px, 20 * var(--u));
}

.esc-post__date {
  font-size: max(10.4px, 13 * var(--u));
  color: #8d8a82;
}

.esc-post__author {
  display: block;
  margin-top: calc(10 * var(--u));
  font-size: max(10.4px, 13 * var(--u));
  color: #8d8a82;
}

.esc-manage {
  display: flex;
  flex-direction: column;
  gap: calc(16 * var(--u));
}

.esc-ranks {
  display: flex;
  flex-wrap: wrap;
  gap: calc(10 * var(--u));
}

.esc-rank {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: calc(130 * var(--u));
  padding: calc(10 * var(--u)) calc(16 * var(--u));
  background: #090c0f;
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 6px;
}
.esc-rank--own {
  border-color: var(--gold-main);
}
.esc-rank--own .esc-rank__name {
  color: var(--gold-light);
}

.esc-rank__name {
  font-size: max(12px, 15 * var(--u));
  font-weight: 600;
}

.esc-rank__count {
  font-size: max(10.4px, 13 * var(--u));
  color: #8d8a82;
}

.esc-help {
  display: grid;
  grid-template-columns: minmax(0, 2fr) minmax(0, 1fr);
  gap: calc(20 * var(--u));
  align-items: start;
}

.esc-help__guide {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: calc(16 * var(--u));
}

.esc-help__side {
  display: flex;
  flex-direction: column;
  gap: calc(16 * var(--u));
}

.esc-guide .esc-card__title {
  margin-bottom: calc(8 * var(--u));
}

.esc-keys {
  display: flex;
  flex-direction: column;
}

.esc-keys__row {
  display: flex;
  align-items: center;
  gap: calc(14 * var(--u));
  padding: calc(10 * var(--u)) 0;
  font-size: max(11.2px, 14 * var(--u));
  color: #b0ada4;
  border-top: 1px solid rgba(255, 255, 255, 0.08);
}
.esc-keys__row:first-child {
  border-top: 0;
  padding-top: 0;
}
.esc-keys__row:last-child {
  padding-bottom: 0;
}
.esc-keys__row--stack {
  flex-direction: column;
  align-items: flex-start;
  gap: 2px;
}
.esc-keys__row .esc-kbd {
  min-width: calc(64 * var(--u));
  text-align: center;
}

.esc-options {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: calc(20 * var(--u));
  align-items: start;
}

.esc-options__palette {
  grid-column: 1/-1;
}

.esc-sliders {
  display: flex;
  flex-direction: column;
  gap: calc(14 * var(--u));
}

.esc-slider {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1.4fr) auto;
  align-items: center;
  gap: calc(16 * var(--u));
}

.esc-slider__label {
  font-size: max(12px, 15 * var(--u));
  color: #b0ada4;
}

.esc-slider__value {
  min-width: 52px;
  font-size: max(11.2px, 14 * var(--u));
  font-weight: 600;
  text-align: right;
  color: var(--gold-light);
}

.esc-slider__input {
  width: 100%;
  height: 22px;
  margin: 0;
  background: transparent;
  cursor: pointer;
  -webkit-appearance: none;
  appearance: none;
}
.esc-slider__input:focus-visible {
  outline: 2px solid var(--gold-light);
  outline-offset: 2px;
}
.esc-slider__input:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}
.esc-slider__input::-webkit-slider-runnable-track {
  height: 4px;
  background: #252f37;
  border-radius: 2px;
}
.esc-slider__input::-webkit-slider-thumb {
  -webkit-appearance: none;
  width: 16px;
  height: 16px;
  margin-top: -6px;
  background: var(--gold-main);
  border: 2px solid #151b21;
  border-radius: 50%;
}

.esc-setting {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: calc(20 * var(--u));
  padding: calc(16 * var(--u)) 0 0;
  margin-top: calc(16 * var(--u));
  border-top: 1px solid rgba(255, 255, 255, 0.08);
}

.esc-setting__text {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
}

.esc-setting__label {
  font-size: max(12px, 15 * var(--u));
  font-weight: 600;
}

.esc-setting__hint {
  font-size: max(10.4px, 13 * var(--u));
  color: #8d8a82;
}

.esc-switch {
  position: relative;
  flex: 0 0 auto;
  width: 46px;
  height: 26px;
  padding: 0;
  background: #252f37;
  border: 1px solid rgba(255, 255, 255, 0.18);
  border-radius: 13px;
  cursor: pointer;
  transition: background-color 0.15s ease, border-color 0.15s ease;
}
.esc-switch:focus-visible {
  outline: 2px solid var(--gold-light);
  outline-offset: 2px;
}
.esc-switch--on {
  background: var(--gold-main);
  border-color: var(--gold-main);
}

.esc-switch__knob {
  position: absolute;
  top: 2px;
  left: 2px;
  width: 20px;
  height: 20px;
  background: #ebe8e1;
  border-radius: 50%;
  transition: transform 0.15s ease;
}
.esc-switch--on .esc-switch__knob {
  transform: translateX(20px);
  background: #14100a;
}

.esc-palettes {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
  gap: calc(12 * var(--u));
  margin-top: calc(14 * var(--u));
}

.esc-palette {
  display: flex;
  flex-direction: column;
  gap: calc(10 * var(--u));
  padding: calc(12 * var(--u));
  text-align: left;
  color: #b0ada4;
  background: #090c0f;
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 6px;
  cursor: pointer;
  transition: border-color 0.12s ease, color 0.12s ease;
}
.esc-palette:hover {
  border-color: rgba(255, 255, 255, 0.18);
  color: #ebe8e1;
}
.esc-palette--active {
  border-color: var(--gold-main);
  color: var(--gold-light);
}
.esc-palette:focus-visible {
  outline: 2px solid var(--gold-light);
  outline-offset: 2px;
}

.esc-palette__swatches {
  display: flex;
  height: 22px;
  border-radius: 4px;
  overflow: hidden;
}

.esc-palette__swatch {
  flex: 1 1 0;
}

.esc-palette__label {
  font-size: max(11.2px, 14 * var(--u));
  font-weight: 600;
}

@media (max-width: 1100px) {
  .esc-panel {
    grid-template-columns: minmax(0, 1fr);
    grid-template-rows: auto minmax(0, 1fr);
  }
  .esc-rail {
    flex-direction: row;
    flex-wrap: wrap;
    align-items: center;
    gap: 12px 20px;
    padding: 14px 18px;
    border-right: 0;
    border-bottom: 1px solid rgba(255, 255, 255, 0.08);
  }
  .esc-brand {
    padding: 0;
  }
  .esc-nav {
    flex-direction: row;
    flex: 1 1 auto;
  }
  .esc-nav__item {
    width: auto;
    padding: 8px 14px;
  }
  .esc-nav__hint, .esc-identity {
    display: none;
  }
  .esc-rail__foot {
    flex-direction: row;
    margin: 0;
    padding: 0;
  }
  .esc-rail__resume, .esc-rail__quit {
    width: auto;
  }
  .esc-content__head, .esc-page {
    padding-left: 20px;
    padding-right: 20px;
  }
  .esc-character {
    grid-template-columns: minmax(0, 1fr);
    grid-template-areas: "id" "stats" "jobs";
  }
  .esc-stats {
    flex-direction: row;
    flex-wrap: wrap;
  }
  .esc-stat {
    flex: 1 1 140px;
  }
  .esc-help, .esc-options {
    grid-template-columns: minmax(0, 1fr);
  }
  .esc-help__guide {
    grid-template-columns: minmax(0, 1fr);
  }
}`, "",{"version":3,"sources":["webpack://./src/features/escMenu/styles.scss"],"names":[],"mappings":"AAuEA;EACE,eAAA;EACA,QAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,yDAnCQ;EAoCR,cA9CK;EA+CL,+BAAA;EACA,0BAAA;EACA,kCAAA;EAKA,sCAAA;EACA,yCAAA;AA1EF;AA4EE;EAEE,kCAAA;EACA,mCAAA;AA3EJ;AA8EE;EACE;IACE,kCAAA;IACA,mCAAA;EA5EJ;AACF;AA+EE;EAAyB,sBAAA;AA5E3B;AA6EE;EAA4B,SAAA;EAAW,UAAA;AAzEzC;AA0EE;EAAK,gBAAA;AAvEP;AAwEE;EAAS,oBAAA;AArEX;;AAwEA;EACE;IAAO,UAAA;EApEP;EAqEA;IAAK,UAAA;EAlEL;AACF;AAoEA;EACE;IAAO,UAAA;IAAY,0BAAA;EAhEnB;EAiEA;IAAK,UAAA;IAAY,wBAAA;EA7DjB;AACF;AA+DA;EACE,aAAA;EACA,sEAAA;EACA,mDAAA;EACA,mDAAA;EACA,mBAnGQ;EAoGR,2CAAA;EACA,kBArFO;EAsFP,2CAAA;EACA,gBAAA;EACA,iCAAA;AA7DF;;AAoEA;EACE,aAAA;EACA,sBAAA;EACA,aAAA;EACA,oEAAA;EACA,mBArHQ;EAsHR,iDAAA;AAjEF;;AAoEA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,kDAAA;AAjEF;;AAoEA;EACE,kDA7Ga;EA8Gb,qCAAA;EACA,sBAAA;EACA,wBAAA;AAjEF;;AAoEA;EACE,oCAAA;EACA,cA9HO;AA6DT;;AAoEA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AAjEF;;AAoEA;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;EACA,WAAA;EACA,wFAAA;EACA,gBAAA;EACA,cAhJO;EAiJP,uBAAA;EACA,SAAA;EACA,kBA5IO;EA6IP,eAAA;EACA,yDAAA;AAjEF;AAmEE;EACE,WAAA;EACA,kBAAA;EACA,OAAA;EACA,QAAA;EACA,WAAA;EACA,UAAA;EACA,kBAAA;EACA,4BAAA;EACA,UAAA;EACA,8BAAA;AAjEJ;AAoEE;EACE,qCAAA;EACA,cAvKG;AAqGP;AAqEE;EACE,qCAAA;EACA,cA5KG;AAyGP;AAqEI;EAAY,UAAA;AAlEhB;AAmEI;EAAkB,wBAAA;AAhEtB;AAnFE;EACE,oCAAA;EACA,mBAAA;AAqFJ;;AAkEA;EACE,qCAAA;EACA,gBAAA;AA/DF;;AAkEA;EACE,oCAAA;EACA,cA1LO;AA2HT;;AAkEA;EACE,aAAA;EACA,sBAAA;EACA,wBAAA;EACA,gBAAA;EACA,gCAAA;AA/DF;;AAkEA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,gDAAA;EACA,mBAnNQ;EAoNR,2CAAA;EACA,kBAtMO;AAuIT;;AAkEA;EACE,mCAAA;EACA,gBAAA;EACA,cApNK;EAqNL,uBAAA;AA/DF;;AAkEA;EACE,qCAAA;EACA,wBAAA;AA/DF;;AAkEA;EACE,8BAAA;EACA,WAAA;AA/DF;;AAkEA;EACE,WAAA;AA/DF;;AAsEA;EACE,aAAA;EACA,sBAAA;EACA,YAAA;EACA,aAAA;AAnEF;;AAsEA;EACE,aAAA;EACA,qBAAA;EACA,8BAAA;EACA,wBAAA;EACA,eAAA;EACA,oEAAA;EACA,kDAAA;AAnEF;;AAsEA;EACE,kDAjPa;EAkPb,gBAAA;EACA,qCAAA;EACA,gBAAA;EACA,cAhQK;AA6LP;;AAsEA;EACE,8BAAA;EACA,mCAAA;EACA,cArQO;AAkMT;;AAsEA;EACE,cAAA;EACA,aAAA;EACA,gBAAA;EACA,oEAAA;EA/PA,wBAAA;EACA,qBAAA;EACA,oCAAA;AA6LF;AA3LE;EAAuB,UAAA;AA8LzB;AA7LE;EAA6B,uBAAA;AAgM/B;AA/LE;EACE,mBA1BM;EA2BN,kBAAA;AAiMJ;AAhMI;EAAU,4BAAA;AAmMd;;AA2DA;EACE,gDAAA;EACA,mBA9RQ;EA+RR,2CAAA;EACA,kBAjRO;AAyNT;AA0DE;EAAW,UAAA;EAAY,gBAAA;AAtDzB;;AAyDA;EACE,kCAAA;EACA,kDArRa;EAsRb,gBAAA;EACA,mCAAA;EACA,cAnSK;AA6OP;AAwDE;EACE,SAAA;EACA,oEAAA;AAtDJ;;AA0DA;EACE,mCAAA;EACA,gBAAA;EACA,cA7SO;EA8SP,eAAA;EACA,qBAAA;EACA,uBAAA;AAvDF;;AA0DA;EACE,gDAAA;EACA,mCAAA;EACA,cArTO;AA8PT;;AA0DA;EACE,+BAAA;EACA,qCAAA;EACA,gBAAA;EACA,cA5TO;AAqQT;AAyDE;EAAY,SAAA;EAAW,kDAAA;AArDzB;;AAwDA;EACE,qBAAA;EACA,gBAAA;EACA,yDA5TQ;EA6TR,oCAAA;EACA,cAxUK;EAyUL,mBA9UQ;EA+UR,2CAAA;EACA,kBAAA;AArDF;;AAwDA;EACE,+CAAA;EACA,qCAAA;EACA,wBAAA;AArDF;;AAyDA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,wBAAA;EACA,gDAAA;EACA,qCAAA;EACA,gBAAA;EACA,gBAAA;EACA,cA9VK;EA+VL,mBArWQ;EAsWR,2CAAA;EACA,kBAzVO;EA0VP,eAAA;EACA,wGAAA;AAtDF;AAwDE;EAAyB,mBA1WjB;EA0WuC,8BAAA;AApDjD;AAqDE;EAA0B,0BAAA;AAlD5B;AAmDE;EAAa,YAAA;EAAc,mBAAA;AA/C7B;AA5RE;EACE,oCAAA;EACA,mBAAA;AA8RJ;AA8CE;EACE,cAAA;EACA,4BAAA;EACA,8BAAA;AA5CJ;AA8CI;EAAW,cAAA;EAAgB,+BAAA;EAAiC,iCAAA;AAzChE;AA0CI;EAAyB,6BAAA;EAA+B,+BAAA;AAtC5D;AAyCE;EACE,cAhXK;EAiXL,uBAAA;EACA,uCAAA;AAvCJ;AAyCI;EAAyB,qCAnXf;EAmXyC,qBApX9C;AA+UT;AAwCE;EACE,cA1XK;EA2XL,uBAAA;EACA,yBAAA;AAtCJ;AAwCI;EAAyB,cA5XpB;EA4XoC,qCA3X/B;EA2XyD,yBAAA;AAnCvE;AAsCE;EACE,+CAAA;EACA,qCAAA;AApCJ;;AAyCA;EACE,oBAAA;EACA,eAAA;EACA,QAAA;EACA,YAAA;EACA,kCAAA;EACA,mBAzZQ;EA0ZR,2CAAA;EACA,kBA1YO;AAoWT;AAwCE;EAAuB,gBAAA;AArCzB;;AAwCA;EACE,+CAAA;EACA,qCAAA;EACA,gBAAA;EACA,cA1ZO;EA2ZP,uBAAA;EACA,SAAA;EACA,kBAAA;EACA,eAAA;EACA,yDAAA;AArCF;AAuCE;EAAU,cAlaL;AA8XP;AAqCE;EAAY,cAAA;EAAgB,4BAAA;AAjC9B;AAiC4D;EAAU,cAAA;AA9BtE;AAzWE;EACE,oCAAA;EACA,mBAAA;AA2WJ;;AA+BA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,gBAAA;AA5BF;;AA+BA;EACE,8BAAA;EACA,qCAAA;EACA,gBAAA;EACA,cAlbO;AAsZT;;AA+BA;EACE,WAAA;EACA,gDAAA;EACA,oBAAA;EACA,mCAAA;EACA,cA3bK;EA4bL,mBArcQ;EAscR,2CAAA;EACA,kBAtbO;EAubP,mCAAA;AA5BF;AA8BE;EAAU,aAAA;EAAe,8BAAA;AA1B3B;AA2BE;EAAiB,cAhcV;AAwaT;AA0BE;EAAU,gCAAA;EAAoB,gBAAA;EAAkB,gBAAA;AArBlD;AAsBE;EAAY,2BAAA;EAAe,eAAA;EAAiB,iBAAA;AAjB9C;;AAoBA;EACE,aAAA;EACA,yBAAA;EACA,wBAAA;EACA,+BAAA;AAjBF;;AAoBA;EACE,qCAAA;EACA,cA7cO;AA4bT;;AAqBA;EACE,eAAA;EACA,QAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,8BAAA;EACA,kCAAA;AAlBF;;AAqBA;EACE,aAAA;EACA,sBAAA;EACA,wBAAA;EACA,uBAAA;EACA,gDAAA;EACA,mBA7eQ;EA8eR,2CAAA;EACA,kBAheO;EAieP,0CAAA;AAlBF;;AAqBA;EACE,kDAlea;EAmeb,gBAAA;EACA,qCAAA;AAlBF;;AAsBA;EAAc,aAAA;EAAe,sBAAA;AAjB7B;;AAmBA;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,2CAAA;EACA,gDAAA;EACA,+CAAA;EACA,+BAAA;AAhBF;AAkBE;EAAU,sCAAA;AAfZ;;AAkBA;EACE,aAAA;EACA,YAAA;EACA,mCAAA;EACA,gBAAA;EACA,uBAAA;AAfF;;AAkBA;EACE,aAAA;EACA,YAAA;EACA,qCAAA;EACA,cA5gBO;AA6fT;;AAkBA;EACE,cAAA;EACA,+BAAA;EACA,qCAAA;EACA,iBAAA;EACA,cAnhBO;AAogBT;;AAkBA;EACE,aAAA;EACA,eAAA;EACA,uBAAA;EACA,iBAAA;AAfF;;AAkBA;EACE,cAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;EACA,uBAAA;EACA,yBAAA;AAfF;AAiBE;EAAQ,mBAjiBL;EAiiBsB,qBAjiBtB;AAohBL;;AAgBA;EAAU,aAAA;EAAe,sBAAA;AAXzB;;AAaA;EACE,aAAA;EACA,mBAAA;EACA,wBAAA;EACA,8BAAA;EACA,+CAAA;AAVF;AAYE;EAAgB,aAAA;EAAe,cAAA;AARjC;;AAWA;EAAiB,cAAA;EAAgB,mCAAA;EAAmB,cArjB3C;AAgjBT;;AAMA;EAAiB,mCAAA;EAAmB,gBAAA;EAAkB,wBAAA;AAAtD;;AAMA;EACE,aAAA;EACA,sDAAA;EACA,4CACE;EAEF,kBAAA;EACA,wBAAA;AALF;;AAQA;EACE,aAAA;EACA,aAAA;EACA,mBAAA;EACA,wBAAA;AALF;;AAQA;EACE,cAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,2BAAA;EACA,4BAAA;EACA,eAAA;EACA,gBAAA;EACA,kDA5kBa;EA6kBb,qCAAA;EACA,wBAAA;EACA,mBAhmBQ;EAimBR,kCAAA;EACA,kBAplBO;EAqlBP,sBAAA;EACA,+BAAA;AALF;AAOE;EAAW,kBAAA;AAJb;;AAOA;EAA0B,YAAA;AAH1B;;AAKA;EACE,kDA3lBa;EA4lBb,gBAAA;EACA,mCAAA;EACA,iBAAA;EACA,uBAAA;AAFF;;AAKA;EACE,eAAA;EACA,qCAAA;EACA,cA9mBO;AA4mBT;;AAKA;EACE,aAAA;EACA,eAAA;EACA,uBAAA;EACA,+BAAA;AAFF;;AAKA;EACE,aAAA;EACA,qBAAA;EACA,uBAAA;EACA,+CAAA;EACA,mBAxoBQ;EAyoBR,2CAAA;EACA,kBAznBO;AAunBT;;AAKA;EAAkB,qCAAA;EAAmB,gBAAA;AAArC;;AACA;EAAkB,qCAAA;EAAmB,wBAAA;AAIrC;;AAFA;EACE,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,wBAAA;AAKF;;AAFA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,gDAAA;EACA,mBA1pBQ;EA2pBR,2CAAA;EACA,kBA7oBO;AAkpBT;;AAFA;EACE,kDA9oBa;EA+oBb,qCAAA;EACA,gBAAA;EACA,wBAAA;AAKF;;AAFA;EAAmB,qCAAA;EAAmB,cA7pB7B;AAoqBT;;AALA;EAAuB,eAAA;AASvB;;AAPA;EAAY,aAAA;EAAe,sBAAA;EAAwB,wBAAA;AAanD;;AAXA;EACE,aAAA;EACA,0CAAA;EACA,2CAAA;EACA,mBAAA;AAcF;;AAXA;EACE,aAAA;EACA,qBAAA;EACA,wBAAA;EACA,YAAA;AAcF;;AAXA;EAAiB,qCAAA;EAAmB,gBAAA;AAgBpC;;AAfA;EAAiB,qCAAA;EAAmB,wBAAA;AAoBpC;;AAnBA;EAAe,qCAAA;EAAmB,cAnrBzB;EAmrByC,iBAAA;AAyBlD;;AAvBA;EACE,iBAAA;EACA,WAAA;EACA,mBAnsBQ;EAosBR,kBAAA;EACA,gBAAA;AA0BF;;AAvBA;EACE,YAAA;EACA,4BAAA;EACA,kBAAA;EACA,2BAAA;AA0BF;;AAnBA;EAAe,kBAAA;AAuBf;;AArBA;EACE,aAAA;EACA,eAAA;EACA,uBAAA;EACA,kCAAA;EACA,kDAAA;AAwBF;;AArBA;EACE,kBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,gDAAA;EACA,mBAAA;EACA,mCAAA;EACA,gBAAA;EACA,cA5tBO;EA6tBP,uBAAA;EACA,SAAA;EACA,oCAAA;EACA,eAAA;EACA,qDAAA;AAwBF;AAtBE;EAAU,cApuBL;AA6vBP;AAxBE;EAAY,wBAAA;EAA0B,qCAAA;AA4BxC;AAruBE;EACE,oCAAA;EACA,mBAAA;AAuuBJ;;AA5BA;EACE,eAAA;EACA,gBAAA;EACA,oCAAA;EACA,kBAAA;EACA,cA7uBO;EA8uBP,mBArvBQ;EAsvBR,mBAAA;AA+BF;AA7BE;EAAW,cAAA;EAAgB,4BAAA;AAiC7B;;AA9BA;EAAqB,aAAA;EAAe,sBAAA;EAAwB,wBAAA;AAoC5D;;AAlCA;EAAgB,aAAA;EAAe,sBAAA;EAAwB,wBAAA;EAAY,gBAAA;AAyCnE;;AAvCA;EACE,aAAA;EACA,qBAAA;EACA,8BAAA;EACA,wBAAA;EACA,eAAA;AA0CF;;AAvCA;EACE,kDAvvBa;EAwvBb,gBAAA;EACA,qCAAA;EACA,gBAAA;EACA,wBAAA;AA0CF;;AAvCA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,iBAAA;AA0CF;AAxCE;EAAK,oCAAA;EAAmB,cA7wBjB;AAyzBT;AA3CE;EAAK,qCAAA;EAAmB,gBAAA;AA+C1B;;AA5CA;EAAY,aAAA;EAAe,sBAAA;EAAwB,wBAAA;EAAY,gBAAA;AAmD/D;;AAjDA;EAAa,aAAA;EAAe,sBAAA;EAAwB,wBAAA;AAuDpD;;AArDA;EACE,gDAAA;EACA,mBAhyBQ;EAiyBR,2CAAA;EACA,uCAAA;EACA,kBApxBO;AA40BT;;AArDA;EACE,aAAA;EACA,qBAAA;EACA,8BAAA;EACA,wBAAA;EACA,iCAAA;AAwDF;;AArDA;EACE,kDA7xBa;EA8xBb,gBAAA;EACA,mCAAA;AAwDF;;AArDA;EAAkB,qCAAA;EAAmB,cA3yB5B;AAq2BT;;AAzDA;EAAoB,cAAA;EAAgB,+BAAA;EAAmB,qCAAA;EAAmB,cA5yBjE;AA42BT;;AA9DA;EAAc,aAAA;EAAe,sBAAA;EAAwB,wBAAA;AAoErD;;AAlEA;EAAa,aAAA;EAAe,eAAA;EAAiB,wBAAA;AAwE7C;;AAtEA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,+BAAA;EACA,gDAAA;EACA,mBAn0BQ;EAo0BR,2CAAA;EACA,kBApzBO;AA63BT;AAvEE;EAAS,8BAAA;AA0EX;AA1E2C;EAAkB,wBAAA;AA6E7D;;AA1EA;EAAkB,mCAAA;EAAmB,gBAAA;AA+ErC;;AA9EA;EAAmB,qCAAA;EAAmB,cAh0B7B;AAm5BT;;AA7EA;EACE,aAAA;EACA,oDAAA;EACA,wBAAA;EACA,kBAAA;AAgFF;;AA7EA;EACE,aAAA;EACA,gDAAA;EACA,wBAAA;AAgFF;;AA7EA;EAAkB,aAAA;EAAe,sBAAA;EAAwB,wBAAA;AAmFzD;;AAjFA;EAA8B,iCAAA;AAqF9B;;AAnFA;EAAY,aAAA;EAAe,sBAAA;AAwF3B;;AAtFA;EACE,aAAA;EACA,mBAAA;EACA,wBAAA;EACA,8BAAA;EACA,qCAAA;EACA,cAh2BO;EAi2BP,+CAAA;AAyFF;AAvFE;EAAgB,aAAA;EAAe,cAAA;AA2FjC;AA1FE;EAAe,iBAAA;AA6FjB;AA3FE;EAAW,sBAAA;EAAwB,uBAAA;EAAyB,QAAA;AAgG9D;AA/FE;EAAW,8BAAA;EAAkB,kBAAA;AAmG/B;;AA5FA;EACE,aAAA;EACA,gDAAA;EACA,wBAAA;EACA,kBAAA;AA+FF;;AA5FA;EAAwB,iBAAA;AAgGxB;;AA9FA;EAAe,aAAA;EAAe,sBAAA;EAAwB,wBAAA;AAoGtD;;AAlGA;EACE,aAAA;EACA,2DAAA;EACA,mBAAA;EACA,wBAAA;AAqGF;;AAlGA;EAAqB,mCAAA;EAAmB,cAh4B/B;AAu+BT;;AArGA;EACE,eAAA;EACA,qCAAA;EACA,gBAAA;EACA,iBAAA;EACA,wBAAA;AAwGF;;AArGA;EACE,WAAA;EACA,YAAA;EACA,SAAA;EACA,uBAAA;EACA,eAAA;EACA,wBAAA;EACA,gBAAA;AAwGF;AA99BE;EACE,oCAAA;EACA,mBAAA;AAg+BJ;AAzGE;EAAa,YAAA;EAAc,mBAAA;AA6G7B;AA3GE;EACE,WAAA;EACA,mBA95BM;EA+5BN,kBAAA;AA6GJ;AA1GE;EACE,wBAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,4BAAA;EACA,yBAAA;EACA,kBAAA;AA4GJ;;AAxGA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,wBAAA;EACA,gCAAA;EACA,+BAAA;EACA,+CAAA;AA2GF;;AAxGA;EAAqB,aAAA;EAAe,sBAAA;EAAwB,QAAA;EAAU,YAAA;AA+GtE;;AA9GA;EAAsB,mCAAA;EAAmB,gBAAA;AAmHzC;;AAlHA;EAAqB,qCAAA;EAAmB,cAl7B/B;AAyiCT;;AArHA;EACE,kBAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,mBAj8BQ;EAk8BR,2CAAA;EACA,mBAAA;EACA,eAAA;EACA,gEAAA;AAwHF;AA5hCE;EACE,oCAAA;EACA,mBAAA;AA8hCJ;AAzHE;EAAQ,4BAAA;EAA8B,8BAAA;AA6HxC;;AA1HA;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,mBA58BK;EA68BL,kBAAA;EACA,gCAAA;AA6HF;AA3HE;EAAoB,2BAAA;EAA6B,mBAAA;AA+HnD;;AA5HA;EACE,aAAA;EACA,4DAAA;EACA,wBAAA;EACA,+BAAA;AA+HF;;AA5HA;EACE,aAAA;EACA,sBAAA;EACA,wBAAA;EACA,4BAAA;EACA,gBAAA;EACA,cA/9BO;EAg+BP,mBA1+BQ;EA2+BR,2CAAA;EACA,kBA39BO;EA49BP,eAAA;EACA,qDAAA;AA+HF;AA7HE;EAAU,uCAz+BE;EAy+B0B,cAv+BjC;AAwmCP;AAhIE;EAAY,8BAAA;EAAgC,wBAAA;AAoI9C;AAhlCE;EACE,oCAAA;EACA,mBAAA;AAklCJ;;AApIA;EAAyB,aAAA;EAAe,YAAA;EAAc,kBAAA;EAAoB,gBAAA;AA2I1E;;AA1IA;EAAuB,WAAA;AA8IvB;;AA7IA;EAAsB,qCAAA;EAAmB,gBAAA;AAkJzC;;AA5IA;EACE;IACE,qCAAA;IACA,uCAAA;EA+IF;EA5IA;IACE,mBAAA;IACA,eAAA;IACA,mBAAA;IACA,cAAA;IACA,kBAAA;IACA,eAAA;IACA,kDAAA;EA8IF;EA3IA;IAAa,UAAA;EA8Ib;EA7IA;IAAW,mBAAA;IAAqB,cAAA;EAiJhC;EAhJA;IAAiB,WAAA;IAAa,iBAAA;EAoJ9B;EAnJA;IAAgC,aAAA;EAsJhC;EArJA;IAAkB,mBAAA;IAAqB,SAAA;IAAW,UAAA;EA0JlD;EAzJA;IAAqC,WAAA;EA4JrC;EA1JA;IAAgC,kBAAA;IAAoB,mBAAA;EA8JpD;EA5JA;IAAiB,qCAAA;IAAuC,wCAAA;EAgKxD;EA/JA;IAAa,mBAAA;IAAqB,eAAA;EAmKlC;EAlKA;IAAY,eAAA;EAqKZ;EApKA;IAA0B,qCAAA;EAuK1B;EAtKA;IAAmB,qCAAA;EAyKnB;AACF","sourcesContent":["// Escape menu. One panel, a left rail for the four sections and a content\n// column that scrolls on its own.\n//\n// Palette: the accent comes from the global `--gold-main/-light/-dark` tokens\n// (main.scss, switched by theme/palette.ts) so the palette picker in Options\n// still recolours the whole menu. Everything else is a fixed set of neutrals.\n// Corner radius is one value everywhere ($radius), spacing and type sizes go\n// through u() and fs() below.\n//\n// Sizing: --u is the pixel of a 1920px-wide reference scaled to the viewport\n// (kept from the previous version, it fixed the 4K overflow), so layouts keep\n// their proportions from 1366 to 3440px wide. Type sizes use fs(), which adds a\n// floor so text never drops below a readable size on small screens, and the\n// panel itself has a minimum size.\n\n@function u($n) {\n  @return calc(#{$n} * var(--u));\n}\n\n// Font size: the scaled value, but never below 80% of the reference size.\n@function fs($n) {\n  @return max(#{$n * 0.8}px, calc(#{$n} * var(--u)));\n}\n\n$ink-900: #090c0f;\n$ink-800: #0f1418;\n$ink-700: #151b21;\n$ink-600: #1c242b;\n$ink-500: #252f37;\n\n$line: rgba(255, 255, 255, 0.08);\n$line-strong: rgba(255, 255, 255, 0.18);\n\n$text: #ebe8e1;\n$text-2: #b0ada4;\n$text-3: #8d8a82;\n\n$danger: #d9786d;\n$danger-soft: rgba(217, 120, 109, 0.14);\n$ok: #7fb58a;\n\n$radius: 6px;\n\n$font-ui: 'Din-pro', 'Segoe UI', system-ui, sans-serif;\n$font-display: 'Marcellus', 'Cinzel', Georgia, serif;\n\n@mixin scroll {\n  scrollbar-gutter: stable;\n  scrollbar-width: thin;\n  scrollbar-color: $ink-500 transparent;\n\n  &::-webkit-scrollbar { width: 8px; }\n  &::-webkit-scrollbar-track { background: transparent; }\n  &::-webkit-scrollbar-thumb {\n    background: $ink-500;\n    border-radius: 4px;\n    &:hover { background: var(--gold-dark); }\n  }\n}\n\n@mixin focus-ring {\n  &:focus-visible {\n    outline: 2px solid var(--gold-light);\n    outline-offset: 2px;\n  }\n}\n\n// ---------------------------------------------------------------------------\n// Overlay and panel\n// ---------------------------------------------------------------------------\n\n.esc-menu {\n  position: fixed;\n  inset: 0;\n  z-index: 9999;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-family: $font-ui;\n  color: $text;\n  background: rgba(4, 6, 8, 0.74);\n  backdrop-filter: blur(5px);\n  animation: esc-fade 0.18s ease-out;\n\n  // Cancels the global resolution-based auto-zoom (theme/uiScale.ts) for this\n  // panel: it already scales itself with --u, and being zoomed twice made it\n  // overflow the screen at 4K.\n  zoom: calc(1 / var(--applied-zoom, 1));\n  --u: clamp(0.7115px, 0.05208vw, 1.7917px);\n\n  &--reduced-motion,\n  &--reduced-motion * {\n    animation-duration: 1ms !important;\n    transition-duration: 1ms !important;\n  }\n\n  @media (prefers-reduced-motion: reduce) {\n    &, & * {\n      animation-duration: 1ms !important;\n      transition-duration: 1ms !important;\n    }\n  }\n\n  *, *::before, *::after { box-sizing: border-box; }\n  h1, h2, h3, p, ul, dl, dd { margin: 0; padding: 0; }\n  ul { list-style: none; }\n  button { font-family: inherit; }\n}\n\n@keyframes esc-fade {\n  from { opacity: 0; }\n  to { opacity: 1; }\n}\n\n@keyframes esc-rise {\n  from { opacity: 0; transform: translateY(8px); }\n  to { opacity: 1; transform: translateY(0); }\n}\n\n.esc-panel {\n  display: grid;\n  grid-template-columns: max(210px, #{u(264)}) minmax(0, 1fr);\n  width: min(max(#{u(1420)}, 940px), 96vw);\n  height: min(max(#{u(900)}, 600px), 92vh);\n  background: $ink-800;\n  border: 1px solid $line-strong;\n  border-radius: $radius;\n  box-shadow: 0 28px 80px rgba(0, 0, 0, 0.65);\n  overflow: hidden;\n  animation: esc-rise 0.2s ease-out;\n}\n\n// ---------------------------------------------------------------------------\n// Left rail\n// ---------------------------------------------------------------------------\n\n.esc-rail {\n  display: flex;\n  flex-direction: column;\n  min-height: 0;\n  padding: u(28) u(18) u(22);\n  background: $ink-900;\n  border-right: 1px solid $line;\n}\n\n.esc-brand {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  padding: 0 u(10) u(26);\n}\n\n.esc-brand__name {\n  font-family: $font-display;\n  font-size: fs(26);\n  letter-spacing: 0.04em;\n  color: var(--gold-light);\n}\n\n.esc-brand__sub {\n  font-size: fs(12);\n  color: $text-3;\n}\n\n.esc-nav {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.esc-nav__item {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  width: 100%;\n  padding: u(12) u(14) u(12) u(18);\n  text-align: left;\n  color: $text-2;\n  background: transparent;\n  border: 0;\n  border-radius: $radius;\n  cursor: pointer;\n  transition: background-color 0.12s ease, color 0.12s ease;\n\n  &::before {\n    content: '';\n    position: absolute;\n    left: 0;\n    top: 22%;\n    bottom: 22%;\n    width: 3px;\n    border-radius: 2px;\n    background: var(--gold-main);\n    opacity: 0;\n    transition: opacity 0.12s ease;\n  }\n\n  &:hover {\n    background: rgba(255, 255, 255, 0.05);\n    color: $text;\n  }\n\n  &--active {\n    background: rgba(255, 255, 255, 0.07);\n    color: $text;\n\n    &::before { opacity: 1; }\n    .esc-nav__label { color: var(--gold-light); }\n  }\n\n  @include focus-ring;\n}\n\n.esc-nav__label {\n  font-size: fs(17);\n  font-weight: 600;\n}\n\n.esc-nav__hint {\n  font-size: fs(12);\n  color: $text-3;\n}\n\n.esc-rail__foot {\n  display: flex;\n  flex-direction: column;\n  gap: u(10);\n  margin-top: auto;\n  padding-top: u(18);\n}\n\n.esc-identity {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  padding: u(12) u(14);\n  background: $ink-700;\n  border: 1px solid $line;\n  border-radius: $radius;\n}\n\n.esc-identity__name {\n  font-size: fs(15);\n  font-weight: 600;\n  color: $text;\n  overflow-wrap: anywhere;\n}\n\n.esc-identity__gold {\n  font-size: fs(13);\n  color: var(--gold-light);\n}\n\n.esc-rail__resume {\n  justify-content: space-between;\n  width: 100%;\n}\n\n.esc-rail__quit {\n  width: 100%;\n}\n\n// ---------------------------------------------------------------------------\n// Content column\n// ---------------------------------------------------------------------------\n\n.esc-content {\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n  min-height: 0;\n}\n\n.esc-content__head {\n  display: flex;\n  align-items: flex-end;\n  justify-content: space-between;\n  gap: u(24);\n  flex-wrap: wrap;\n  padding: u(30) u(40) u(20);\n  border-bottom: 1px solid $line;\n}\n\n.esc-content__title {\n  font-family: $font-display;\n  font-weight: 400;\n  font-size: fs(36);\n  line-height: 1.1;\n  color: $text;\n}\n\n.esc-content__lead {\n  margin-top: u(6);\n  font-size: fs(15);\n  color: $text-2;\n}\n\n.esc-page {\n  flex: 1 1 auto;\n  min-height: 0;\n  overflow-y: auto;\n  padding: u(28) u(40) u(36);\n  @include scroll;\n}\n\n// ---------------------------------------------------------------------------\n// Shared pieces\n// ---------------------------------------------------------------------------\n\n.esc-card {\n  padding: u(22) u(24);\n  background: $ink-700;\n  border: 1px solid $line;\n  border-radius: $radius;\n\n  &--flush { padding: 0; overflow: hidden; }\n}\n\n.esc-card__title {\n  margin-bottom: u(14);\n  font-family: $font-display;\n  font-weight: 400;\n  font-size: fs(20);\n  color: $text;\n\n  &--padded {\n    margin: 0;\n    padding: u(18) u(24) u(12);\n  }\n}\n\n.esc-prose {\n  font-size: fs(15);\n  line-height: 1.6;\n  color: $text-2;\n  max-width: 68ch;\n  white-space: pre-wrap;\n  overflow-wrap: anywhere;\n}\n\n.esc-empty {\n  padding: u(20) u(24);\n  font-size: fs(15);\n  color: $text-3;\n}\n\n.esc-hint {\n  margin-top: u(10);\n  font-size: fs(13);\n  line-height: 1.5;\n  color: $text-3;\n\n  &--padded { margin: 0; padding: 0 u(24) u(18); }\n}\n\n.esc-kbd {\n  display: inline-block;\n  padding: 2px 8px;\n  font-family: $font-ui;\n  font-size: fs(12);\n  color: $text;\n  background: $ink-500;\n  border: 1px solid $line-strong;\n  border-radius: 4px;\n}\n\n.esc-code {\n  font-family: Consolas, 'Courier New', monospace;\n  font-size: fs(14);\n  color: var(--gold-light);\n}\n\n// Buttons\n.esc-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: u(10);\n  padding: u(10) u(18);\n  font-size: fs(14);\n  font-weight: 600;\n  line-height: 1.2;\n  color: $text;\n  background: $ink-600;\n  border: 1px solid $line-strong;\n  border-radius: $radius;\n  cursor: pointer;\n  transition: background-color 0.12s ease, border-color 0.12s ease, color 0.12s ease, transform 0.08s ease;\n\n  &:hover:not(:disabled) { background: $ink-500; border-color: var(--gold-dark); }\n  &:active:not(:disabled) { transform: translateY(1px); }\n  &:disabled { opacity: 0.4; cursor: not-allowed; }\n  @include focus-ring;\n\n  &--primary {\n    color: #14100a;\n    background: var(--gold-main);\n    border-color: var(--gold-main);\n\n    .esc-kbd { color: #14100a; background: rgba(0, 0, 0, 0.14); border-color: rgba(0, 0, 0, 0.25); }\n    &:hover:not(:disabled) { background: var(--gold-light); border-color: var(--gold-light); }\n  }\n\n  &--danger {\n    color: $danger;\n    background: transparent;\n    border-color: rgba(217, 120, 109, 0.45);\n\n    &:hover:not(:disabled) { background: $danger-soft; border-color: $danger; }\n  }\n\n  &--quiet {\n    color: $text-3;\n    background: transparent;\n    border-color: transparent;\n\n    &:hover:not(:disabled) { color: $danger; background: $danger-soft; border-color: transparent; }\n  }\n\n  &--sm {\n    padding: u(6) u(12);\n    font-size: fs(13);\n  }\n}\n\n// Segmented control (faction switcher, management sections)\n.esc-segments {\n  display: inline-flex;\n  flex-wrap: wrap;\n  gap: 2px;\n  padding: 3px;\n  margin-bottom: u(18);\n  background: $ink-900;\n  border: 1px solid $line;\n  border-radius: $radius;\n\n  .esc-content__head & { margin-bottom: 0; }\n}\n\n.esc-segment {\n  padding: u(8) u(16);\n  font-size: fs(14);\n  font-weight: 600;\n  color: $text-2;\n  background: transparent;\n  border: 0;\n  border-radius: 4px;\n  cursor: pointer;\n  transition: background-color 0.12s ease, color 0.12s ease;\n\n  &:hover { color: $text; }\n  &--active { color: #14100a; background: var(--gold-main); &:hover { color: #14100a; } }\n  @include focus-ring;\n}\n\n// Forms\n.esc-form {\n  display: flex;\n  flex-direction: column;\n  gap: u(8);\n  max-width: 640px;\n}\n\n.esc-label {\n  margin-top: u(6);\n  font-size: fs(13);\n  font-weight: 600;\n  color: $text-2;\n}\n\n.esc-field {\n  width: 100%;\n  padding: u(10) u(12);\n  font-family: inherit;\n  font-size: fs(15);\n  color: $text;\n  background: $ink-900;\n  border: 1px solid $line-strong;\n  border-radius: $radius;\n  transition: border-color 0.12s ease;\n\n  &:focus { outline: none; border-color: var(--gold-main); }\n  &::placeholder { color: $text-3; }\n\n  &--area { min-height: u(140); resize: vertical; line-height: 1.5; }\n  &--inline { width: u(120); min-width: 90px; text-align: right; }\n}\n\n.esc-form__actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: u(10);\n  margin-top: u(12);\n}\n\n.esc-form__error {\n  font-size: fs(14);\n  color: $danger;\n}\n\n// Dialog\n.esc-dialog-scrim {\n  position: fixed;\n  inset: 0;\n  z-index: 20;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: rgba(4, 6, 8, 0.7);\n  animation: esc-fade 0.12s ease-out;\n}\n\n.esc-dialog {\n  display: flex;\n  flex-direction: column;\n  gap: u(12);\n  width: min(460px, 90vw);\n  padding: u(26) u(28);\n  background: $ink-700;\n  border: 1px solid $line-strong;\n  border-radius: $radius;\n  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.6);\n}\n\n.esc-dialog__title {\n  font-family: $font-display;\n  font-weight: 400;\n  font-size: fs(24);\n}\n\n// Lists\n.esc-roster { display: flex; flex-direction: column; }\n\n.esc-roster__row {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: u(8) u(16);\n  padding: u(12) u(24);\n  border-top: 1px solid $line;\n  min-height: u(54);\n\n  &:hover { background: rgba(255, 255, 255, 0.025); }\n}\n\n.esc-roster__name {\n  flex: 1 1 28%;\n  min-width: 0;\n  font-size: fs(15);\n  font-weight: 600;\n  overflow-wrap: anywhere;\n}\n\n.esc-roster__rank {\n  flex: 1 1 22%;\n  min-width: 0;\n  font-size: fs(14);\n  color: $text-2;\n}\n\n.esc-roster__seen {\n  flex: 0 0 auto;\n  min-width: u(130);\n  font-size: fs(13);\n  text-align: right;\n  color: $text-3;\n}\n\n.esc-roster__actions {\n  display: flex;\n  flex-wrap: wrap;\n  gap: u(8);\n  margin-left: auto;\n}\n\n.esc-presence {\n  flex: 0 0 auto;\n  width: 9px;\n  height: 9px;\n  border-radius: 50%;\n  background: transparent;\n  border: 1px solid $text-3;\n\n  &--on { background: $ok; border-color: $ok; }\n}\n\n.esc-kv { display: flex; flex-direction: column; }\n\n.esc-kv__row {\n  display: flex;\n  align-items: center;\n  gap: u(14);\n  padding: u(12) 0;\n  border-top: 1px solid $line;\n\n  &:first-child { border-top: 0; padding-top: 0; }\n}\n\n.esc-kv__label { flex: 1 1 auto; font-size: fs(15); color: $text-2; }\n.esc-kv__value { font-size: fs(15); font-weight: 600; color: var(--gold-light); }\n\n// ---------------------------------------------------------------------------\n// Personnage\n// ---------------------------------------------------------------------------\n\n.esc-character {\n  display: grid;\n  grid-template-columns: minmax(0, 1.7fr) minmax(0, 1fr);\n  grid-template-areas:\n    'id stats'\n    'jobs stats';\n  align-items: start;\n  gap: u(20);\n}\n\n.esc-identitycard {\n  grid-area: id;\n  display: flex;\n  align-items: center;\n  gap: u(24);\n}\n\n.esc-avatar {\n  flex: 0 0 auto;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: u(112);\n  height: u(112);\n  min-width: 76px;\n  min-height: 76px;\n  font-family: $font-display;\n  font-size: fs(38);\n  color: var(--gold-light);\n  background: $ink-600;\n  border: 1px solid var(--gold-dark);\n  border-radius: $radius;\n  background-size: cover;\n  background-position: center 30%;\n\n  &--photo { color: transparent; }\n}\n\n.esc-identitycard__text { min-width: 0; }\n\n.esc-identitycard__name {\n  font-family: $font-display;\n  font-weight: 400;\n  font-size: fs(30);\n  line-height: 1.15;\n  overflow-wrap: anywhere;\n}\n\n.esc-identitycard__meta {\n  margin-top: 2px;\n  font-size: fs(14);\n  color: $text-3;\n}\n\n.esc-chips {\n  display: flex;\n  flex-wrap: wrap;\n  gap: u(8);\n  margin-top: u(14);\n}\n\n.esc-chip {\n  display: flex;\n  align-items: baseline;\n  gap: u(8);\n  padding: u(6) u(12);\n  background: $ink-900;\n  border: 1px solid $line-strong;\n  border-radius: $radius;\n}\n\n.esc-chip__name { font-size: fs(14); font-weight: 600; }\n.esc-chip__rank { font-size: fs(13); color: var(--gold-light); }\n\n.esc-stats {\n  grid-area: stats;\n  display: flex;\n  flex-direction: column;\n  gap: u(12);\n}\n\n.esc-stat {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  padding: u(18) u(22);\n  background: $ink-700;\n  border: 1px solid $line;\n  border-radius: $radius;\n}\n\n.esc-stat__value {\n  font-family: $font-display;\n  font-size: fs(32);\n  line-height: 1.1;\n  color: var(--gold-light);\n}\n\n.esc-stat__label { font-size: fs(13); color: $text-3; }\n\n.esc-character__jobs { grid-area: jobs; }\n\n.esc-jobs { display: flex; flex-direction: column; gap: u(18); }\n\n.esc-job {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) auto;\n  gap: u(6) u(16);\n  align-items: center;\n}\n\n.esc-job__head {\n  display: flex;\n  align-items: baseline;\n  gap: u(10);\n  min-width: 0;\n}\n\n.esc-job__name { font-size: fs(16); font-weight: 600; }\n.esc-job__rank { font-size: fs(13); color: var(--gold-light); }\n.esc-job__xp { font-size: fs(13); color: $text-3; text-align: right; }\n\n.esc-meter {\n  grid-column: 1 / -1;\n  height: 6px;\n  background: $ink-900;\n  border-radius: 3px;\n  overflow: hidden;\n}\n\n.esc-meter__fill {\n  height: 100%;\n  background: var(--gold-main);\n  border-radius: 3px;\n  transition: width 0.3s ease;\n}\n\n// ---------------------------------------------------------------------------\n// Faction\n// ---------------------------------------------------------------------------\n\n.esc-faction { position: relative; }\n\n.esc-subtabs {\n  display: flex;\n  flex-wrap: wrap;\n  gap: u(4);\n  margin-bottom: u(22);\n  border-bottom: 1px solid $line;\n}\n\n.esc-subtab {\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n  gap: u(8);\n  padding: u(10) u(16);\n  margin-bottom: -1px;\n  font-size: fs(15);\n  font-weight: 600;\n  color: $text-2;\n  background: transparent;\n  border: 0;\n  border-bottom: 2px solid transparent;\n  cursor: pointer;\n  transition: color 0.12s ease, border-color 0.12s ease;\n\n  &:hover { color: $text; }\n  &--active { color: var(--gold-light); border-bottom-color: var(--gold-main); }\n  @include focus-ring;\n}\n\n.esc-subtab__count {\n  min-width: 22px;\n  padding: 1px 7px;\n  font-size: fs(12);\n  text-align: center;\n  color: $text-2;\n  background: $ink-600;\n  border-radius: 11px;\n\n  &--alert { color: #14100a; background: var(--gold-main); }\n}\n\n.esc-faction__body { display: flex; flex-direction: column; gap: u(20); }\n\n.esc-overview { display: flex; flex-direction: column; gap: u(16); max-width: 760px; }\n\n.esc-overview__id {\n  display: flex;\n  align-items: flex-end;\n  justify-content: space-between;\n  gap: u(20);\n  flex-wrap: wrap;\n}\n\n.esc-overview__name {\n  font-family: $font-display;\n  font-weight: 400;\n  font-size: fs(34);\n  line-height: 1.1;\n  color: var(--gold-light);\n}\n\n.esc-overview__rank {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  text-align: right;\n\n  dt { font-size: fs(12); color: $text-3; }\n  dd { font-size: fs(18); font-weight: 600; }\n}\n\n.esc-news { display: flex; flex-direction: column; gap: u(20); max-width: 820px; }\n\n.esc-posts { display: flex; flex-direction: column; gap: u(14); }\n\n.esc-post {\n  padding: u(20) u(24);\n  background: $ink-700;\n  border: 1px solid $line;\n  border-left: 3px solid var(--gold-main);\n  border-radius: $radius;\n}\n\n.esc-post__head {\n  display: flex;\n  align-items: baseline;\n  justify-content: space-between;\n  gap: u(16);\n  margin-bottom: u(8);\n}\n\n.esc-post__title {\n  font-family: $font-display;\n  font-weight: 400;\n  font-size: fs(20);\n}\n\n.esc-post__date { font-size: fs(13); color: $text-3; }\n.esc-post__author { display: block; margin-top: u(10); font-size: fs(13); color: $text-3; }\n\n.esc-manage { display: flex; flex-direction: column; gap: u(16); }\n\n.esc-ranks { display: flex; flex-wrap: wrap; gap: u(10); }\n\n.esc-rank {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  min-width: u(130);\n  padding: u(10) u(16);\n  background: $ink-900;\n  border: 1px solid $line;\n  border-radius: $radius;\n\n  &--own { border-color: var(--gold-main); .esc-rank__name { color: var(--gold-light); } }\n}\n\n.esc-rank__name { font-size: fs(15); font-weight: 600; }\n.esc-rank__count { font-size: fs(13); color: $text-3; }\n\n// ---------------------------------------------------------------------------\n// Aide\n// ---------------------------------------------------------------------------\n\n.esc-help {\n  display: grid;\n  grid-template-columns: minmax(0, 2fr) minmax(0, 1fr);\n  gap: u(20);\n  align-items: start;\n}\n\n.esc-help__guide {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: u(16);\n}\n\n.esc-help__side { display: flex; flex-direction: column; gap: u(16); }\n\n.esc-guide .esc-card__title { margin-bottom: u(8); }\n\n.esc-keys { display: flex; flex-direction: column; }\n\n.esc-keys__row {\n  display: flex;\n  align-items: center;\n  gap: u(14);\n  padding: u(10) 0;\n  font-size: fs(14);\n  color: $text-2;\n  border-top: 1px solid $line;\n\n  &:first-child { border-top: 0; padding-top: 0; }\n  &:last-child { padding-bottom: 0; }\n\n  &--stack { flex-direction: column; align-items: flex-start; gap: 2px; }\n  .esc-kbd { min-width: u(64); text-align: center; }\n}\n\n// ---------------------------------------------------------------------------\n// Options\n// ---------------------------------------------------------------------------\n\n.esc-options {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: u(20);\n  align-items: start;\n}\n\n.esc-options__palette { grid-column: 1 / -1; }\n\n.esc-sliders { display: flex; flex-direction: column; gap: u(14); }\n\n.esc-slider {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) minmax(0, 1.4fr) auto;\n  align-items: center;\n  gap: u(16);\n}\n\n.esc-slider__label { font-size: fs(15); color: $text-2; }\n\n.esc-slider__value {\n  min-width: 52px;\n  font-size: fs(14);\n  font-weight: 600;\n  text-align: right;\n  color: var(--gold-light);\n}\n\n.esc-slider__input {\n  width: 100%;\n  height: 22px;\n  margin: 0;\n  background: transparent;\n  cursor: pointer;\n  -webkit-appearance: none;\n  appearance: none;\n  @include focus-ring;\n\n  &:disabled { opacity: 0.4; cursor: not-allowed; }\n\n  &::-webkit-slider-runnable-track {\n    height: 4px;\n    background: $ink-500;\n    border-radius: 2px;\n  }\n\n  &::-webkit-slider-thumb {\n    -webkit-appearance: none;\n    width: 16px;\n    height: 16px;\n    margin-top: -6px;\n    background: var(--gold-main);\n    border: 2px solid $ink-700;\n    border-radius: 50%;\n  }\n}\n\n.esc-setting {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: u(20);\n  padding: u(16) 0 0;\n  margin-top: u(16);\n  border-top: 1px solid $line;\n}\n\n.esc-setting__text { display: flex; flex-direction: column; gap: 2px; min-width: 0; }\n.esc-setting__label { font-size: fs(15); font-weight: 600; }\n.esc-setting__hint { font-size: fs(13); color: $text-3; }\n\n.esc-switch {\n  position: relative;\n  flex: 0 0 auto;\n  width: 46px;\n  height: 26px;\n  padding: 0;\n  background: $ink-500;\n  border: 1px solid $line-strong;\n  border-radius: 13px;\n  cursor: pointer;\n  transition: background-color 0.15s ease, border-color 0.15s ease;\n  @include focus-ring;\n\n  &--on { background: var(--gold-main); border-color: var(--gold-main); }\n}\n\n.esc-switch__knob {\n  position: absolute;\n  top: 2px;\n  left: 2px;\n  width: 20px;\n  height: 20px;\n  background: $text;\n  border-radius: 50%;\n  transition: transform 0.15s ease;\n\n  .esc-switch--on & { transform: translateX(20px); background: #14100a; }\n}\n\n.esc-palettes {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));\n  gap: u(12);\n  margin-top: u(14);\n}\n\n.esc-palette {\n  display: flex;\n  flex-direction: column;\n  gap: u(10);\n  padding: u(12);\n  text-align: left;\n  color: $text-2;\n  background: $ink-900;\n  border: 1px solid $line;\n  border-radius: $radius;\n  cursor: pointer;\n  transition: border-color 0.12s ease, color 0.12s ease;\n\n  &:hover { border-color: $line-strong; color: $text; }\n  &--active { border-color: var(--gold-main); color: var(--gold-light); }\n  @include focus-ring;\n}\n\n.esc-palette__swatches { display: flex; height: 22px; border-radius: 4px; overflow: hidden; }\n.esc-palette__swatch { flex: 1 1 0; }\n.esc-palette__label { font-size: fs(14); font-weight: 600; }\n\n// ---------------------------------------------------------------------------\n// Narrow screens: the rail becomes a top bar\n// ---------------------------------------------------------------------------\n\n@media (max-width: 1100px) {\n  .esc-panel {\n    grid-template-columns: minmax(0, 1fr);\n    grid-template-rows: auto minmax(0, 1fr);\n  }\n\n  .esc-rail {\n    flex-direction: row;\n    flex-wrap: wrap;\n    align-items: center;\n    gap: 12px 20px;\n    padding: 14px 18px;\n    border-right: 0;\n    border-bottom: 1px solid $line;\n  }\n\n  .esc-brand { padding: 0; }\n  .esc-nav { flex-direction: row; flex: 1 1 auto; }\n  .esc-nav__item { width: auto; padding: 8px 14px; }\n  .esc-nav__hint, .esc-identity { display: none; }\n  .esc-rail__foot { flex-direction: row; margin: 0; padding: 0; }\n  .esc-rail__resume, .esc-rail__quit { width: auto; }\n\n  .esc-content__head, .esc-page { padding-left: 20px; padding-right: 20px; }\n\n  .esc-character { grid-template-columns: minmax(0, 1fr); grid-template-areas: 'id' 'stats' 'jobs'; }\n  .esc-stats { flex-direction: row; flex-wrap: wrap; }\n  .esc-stat { flex: 1 1 140px; }\n  .esc-help, .esc-options { grid-template-columns: minmax(0, 1fr); }\n  .esc-help__guide { grid-template-columns: minmax(0, 1fr); }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
